import { WithEnterpriseId } from '@mews-commander/types';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useLoyaltyIntegration = ({ enterpriseId }: WithEnterpriseId) => {
    const { data, isFetching } = useRepositoryQuery(
        'integrations',
        'getAllLoyalty',
        { enterpriseId },
        {
            select: (result) => {
                const integration = result?.integrations?.[0]; // currently we only support one active loyalty integration
                return {
                    loyaltyIntegration: integration
                        ? {
                              id: integration.id,
                              requiredFields: integration.requiredFields,
                          }
                        : null,
                };
            },
        }
    );

    return { loyaltyIntegration: data?.loyaltyIntegration, isFetching };
};
